module.exports = __webpack_public_path__ + "static/media/ibd_arm1.a4d95cc8.png";